import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
function Camping() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 6;

  const campingSites = [
    {
      id: 0,
      slug: "rishikesh-riverfront-camping",
      title: "Riverfront Escape",
      location: "Rishikesh, Uttarakhand",
      description: "Sleep under the stars with the soothing sound of the Ganga flowing beside you. Yoga and meditation included.",
      image: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹2,499",
      rating: 4.8,
      duration: "3 days",
      guests: 20,
    },
    {
      id: 1,
      slug: "manali-mountain-river-camping",
      title: "Mountain River Camping",
      location: "Manali, Himachal Pradesh",
      description: "Experience Himalayan river camping with trekking, bonfire nights, and serene nature views.",
      image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹3,299",
      rating: 4.9,
      duration: "4 days",
      guests: 25,
    },
    {
      id: 2,
      slug: "spiti-riverside-retreat",
      title: "Secluded Riverside Retreat",
      location: "Spiti Valley, Himachal Pradesh",
      description: "A remote camping experience along the icy rivers of Spiti. Perfect for digital detox and solitude.",
      image: "https://images.unsplash.com/photo-1519340333755-abea3e9c2521?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹4,999",
      rating: 5.0,
      duration: "5 days",
      guests: 15,
    },
    {
      id: 3,
      slug: "ladakh-alpine-lake-camping",
      title: "Alpine Lake Camping",
      location: "Ladakh",
      description: "Crystal clear alpine lakes surrounded by snow-capped peaks. Perfect for adventure enthusiasts and photographers.",
      image: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹5,499",
      rating: 4.7,
      duration: "6 days",
      guests: 18,
    },
    {
      id: 4,
      title: "Forest Valley Base Camp",
      location: "Dharamshala, Himachal Pradesh",
      description: "Nestled in dense pine forests with panoramic valley views. Includes guided nature walks and stargazing sessions.",
      image: "https://images.unsplash.com/photo-1446521653236-cd1b432805dc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹2,799",
      rating: 4.6,
      duration: "3 days",
      guests: 22,
    },
    {
      id: 5,
      title: "Desert Dunes Experience",
      location: "Jaisalmer, Rajasthan",
      description: "Camp under the desert sky with camel safaris, campfires, and traditional Rajasthani meals.",
      image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹1,999",
      rating: 4.5,
      duration: "2 days",
      guests: 30,
    },
    {
      id: 6,
      title: "Waterfall Adventure Camp",
      location: "Coorg, Karnataka",
      description: "Explore cascading waterfalls, coffee plantations, and dense evergreen forests with expert guides.",
      image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹3,599",
      rating: 4.8,
      duration: "4 days",
      guests: 24,
    },
    {
      id: 7,
      title: "Coastal Cliff Camping",
      location: "Gokarna, Karnataka",
      description: "Camp right on pristine beaches with fresh seafood, yoga sessions, and sunset views over the Arabian Sea.",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹2,299",
      rating: 4.7,
      duration: "3 days",
      guests: 28,
    },
    {
      id: 8,
      title: "Glacier Trek Base Camp",
      location: "Auli, Uttarakhand",
      description: "Experience the majestic Chorabari Glacier with guided treks, ice cave exploration, and high-altitude camping.",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080",
      price: "₹6,299",
      rating: 4.9,
      duration: "7 days",
      guests: 12,
    },
  ];

  const heroSlides = [
    {
      title: "River-Side Camping in the Himalayas",
      subtitle: "PlanBanLo curates premium camping experiences along Himalayan rivers, blending adventure, serenity, and wellness.",
      image: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1200",
    },
    {
      title: "Adventure Awaits",
      subtitle: "Discover hidden gems and create unforgettable memories with friends and family.",
      image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1200",
    },
    {
      title: "Nature's Best Kept Secrets",
      subtitle: "Experience pristine landscapes and authentic camping culture across India.",
      image: "https://images.unsplash.com/photo-1519904981063-b0cf448d479e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1200",
    },
  ];

  const totalPages = Math.ceil(campingSites.length / itemsPerPage);
  const startIdx = currentPage * itemsPerPage;
  const paginatedSites = campingSites.slice(startIdx, startIdx + itemsPerPage);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);

  return (<>
    <Helmet>
      <title>Retreats| PlanBanaLo</title>
      <meta
        name="description"
        content=" PlanBanaLo to book camping trips, yoga retreats, and adventure experiences."
      />
    </Helmet>
    <div style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {/* Hero Carousel Section */}
      <section style={{
        position: 'relative',
        height: '600px',
        overflow: 'hidden',
        background: '#000',
      }}>
        <div style={{ position: 'relative', height: '100%' }}>
          {heroSlides.map((slide, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                opacity: currentSlide === index ? 1 : 0,
                transition: 'opacity 0.5s ease-in-out',
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(135deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.3) 100%)',
              }} />
              <div style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
                textAlign: 'center',
                padding: '40px 20px',
              }}>
                <h1 style={{
                  fontSize: 'clamp(2rem, 5vw, 4rem)',
                  fontWeight: 'bold',
                  marginBottom: '20px',
                  textShadow: '2px 2px 8px rgba(0,0,0,0.5)',
                }}>
                  {slide.title}
                </h1>
                <p style={{
                  fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                  maxWidth: '700px',
                  textShadow: '1px 1px 4px rgba(0,0,0,0.5)',
                  color: 'rgba(255,255,255,0.9)',
                }}>
                  {slide.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Previous Button */}
        <button
          onClick={prevSlide}
          style={{
            position: 'absolute',
            left: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.3)',
            border: 'none',
            color: '#fff',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            transition: 'background 0.3s',
            fontSize: '24px',
          }}
          onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.5)'}
          onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
        >
          {'‹'}
        </button>

        {/* Next Button */}
        <button
          onClick={nextSlide}
          style={{
            position: 'absolute',
            right: '20px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(255,255,255,0.3)',
            border: 'none',
            color: '#fff',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            transition: 'background 0.3s',
            fontSize: '24px',
          }}
          onMouseEnter={(e) => e.target.style.background = 'rgba(255,255,255,0.5)'}
          onMouseLeave={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}
        >
          {'›'}
        </button>

        {/* Slide Indicators */}
        <div style={{
          position: 'absolute',
          bottom: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '10px',
          zIndex: 10,
        }}>
          {heroSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              style={{
                width: currentSlide === index ? '32px' : '10px',
                height: '10px',
                borderRadius: '5px',
                border: 'none',
                background: currentSlide === index ? '#fff' : 'rgba(255,255,255,0.5)',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
            />
          ))}
        </div>
      </section>

      {/* Camping Sites Section with Pagination */}
      <section style={{
        padding: '80px 20px',
        background: '#f8f9fa',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
        }}>
          <div style={{
            textAlign: 'center',
            marginBottom: '60px',
          }}>
            <h2 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 'bold',
              marginBottom: '15px',
              color: '#1a1a1a',
            }}>
              Our River Side Camping Destinations
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#666',
              maxWidth: '600px',
              margin: '0 auto',
            }}>
              Explore our curated collection of premium camping destinations across India
            </p>
          </div>

          {/* Cards Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '30px',
            marginBottom: '60px',
          }}>
            {paginatedSites.map((site, index) => (
              <Link
                to={`/camping/${site.slug}`}
                style={{ textDecoration: 'none', color: 'inherit' }}
                key={index}
              >
                <div
                  style={{
                    background: '#fff',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.08)';
                  }}
                >
                  {/* Image Container */}
                  <div style={{
                    position: 'relative',
                    height: '240px',
                    overflow: 'hidden',
                    background: '#e0e0e0',
                  }}>
                    <img
                      src={site.image}
                      alt={site.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s',
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    />
                    {/* Rating Badge */}
                    <div style={{
                      position: 'absolute',
                      top: '15px',
                      right: '15px',
                      background: '#2f8b2f',
                      color: '#fff',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      fontWeight: 'bold',
                      fontSize: '0.9rem',
                    }}>
                      ⭐ {site.rating}
                    </div>
                  </div>

                  {/* Card Content */}
                  <div style={{ padding: '25px' }}>
                    <h3 style={{
                      fontSize: '1.4rem',
                      fontWeight: 'bold',
                      marginBottom: '8px',
                      color: '#1a1a1a',
                    }}>
                      {site.title}
                    </h3>

                    {/* Location */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      marginBottom: '12px',
                      color: '#666',
                      fontSize: '0.95rem',
                    }}>
                      <span style={{ fontSize: '18px', color: '#ff6b6b' }}>📍</span>
                      {site.location}
                    </div>

                    <p style={{
                      color: '#555',
                      fontSize: '0.95rem',
                      marginBottom: '15px',
                      lineHeight: '1.5',
                      minHeight: '50px',
                    }}>
                      {site.description}
                    </p>

                    {/* Info Row */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '10px',
                      marginBottom: '20px',
                      paddingBottom: '15px',
                      borderBottom: '1px solid #eee',
                      fontSize: '0.9rem',
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{ fontSize: '16px' }}>🔥</span>
                        <span>{site.duration}</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{ fontSize: '16px' }}>👥</span>
                        <span>{site.guests} guests</span>
                      </div>
                    </div>

                    {/* Price and Button */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                      <span style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#131212',
                      }}>
                        {site.price}
                      </span>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          window.location.href = `/camping/${site.slug}`;
                        }}
                        style={{
                          background: '#40d140',
                          color: '#fff',
                          border: 'none',
                          padding: '10px 24px',
                          borderRadius: '8px',
                          fontWeight: '600',
                          cursor: 'pointer',
                          fontSize: '0.95rem',
                          transition: 'background 0.3s',
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#fff';
                          e.target.style.color = '#000000';
                          e.target.style.border = '1px solid #40d140';

                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = '#40d140';
                          e.target.style.color = '#fff';
                        }}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Pagination Controls */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '15px',
            flexWrap: 'wrap',
          }}>
            <button
              onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
              disabled={currentPage === 0}
              style={{
                padding: '10px 20px',
                background: currentPage === 0 ? '#ddd' : '#40d140',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                fontWeight: '600',
                transition: 'background 0.3s',
              }}
              onMouseEnter={(e) => {
                if (currentPage !== 0) e.target.style.background = '#fff';
                e.target.style.color = '#000000';
                e.target.style.border = '2px solid #40d140';
              }}
              onMouseLeave={(e) => {
                if (currentPage !== 0) e.target.style.background = '#40d140';
                e.target.style.color = '#fff';
                e.target.style.border = 'none';
              }}
            >
              ← Previous
            </button>

            <div style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}>
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '8px',
                    border: 'none',
                    background: currentPage === i ? '#2ba22b' : '#e0e0e0',
                    color: currentPage === i ? '#fff' : '#333',
                    cursor: 'pointer',
                    fontWeight: '600',
                    transition: 'all 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    if (currentPage !== i) {
                      e.target.style.background = '#40d140';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (currentPage !== i) {
                      e.target.style.background = '#e0e0e0';
                    }
                  }}
                >
                  {i + 1}
                </button>
              ))}
            </div>

            <button
              onClick={() => setCurrentPage(Math.min(totalPages - 1, currentPage + 1))}
              disabled={currentPage === totalPages - 1}
              style={{
                padding: '10px 20px',
                background: currentPage === totalPages - 1 ? '#ddd' : '#40d140',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: currentPage === totalPages - 1 ? 'not-allowed' : 'pointer',
                fontWeight: '600',
                transition: 'background 0.3s',
              }}
              onMouseEnter={(e) => {
                if (currentPage !== totalPages - 1) e.target.style.background = '#fff';
                e.target.style.color = '#000000';
                e.target.style.border = '2px solid #40d140';
              }}
              onMouseLeave={(e) => {
                if (currentPage !== totalPages - 1) e.target.style.background = '#40d140';
                e.target.style.color = '#fff';
                e.target.style.border = 'none';
              }}
            >
              Next →
            </button>
          </div>
        </div>
      </section>
      <section style={{
        background: 'linear-gradient(135deg, #1B4332, #40916C)',
        padding: '20px 20px',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
            fontWeight: 'bold',
            color: '#fff',
            marginBottom: '20px',
          }}>
            Ready to Experience Yoga Retreats Like Never Before?
          </h2>
          <p style={{
            fontSize: '1.1rem',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '30px',
          }}>
            Join thousands of adventure seekers and nature lovers. Book your perfect camping retreat today!
          </p>
          <Link to="/contactus"> <button style={{
            background: '#fff',
            color: '#110b0b',
            border: 'none',
            padding: '15px 40px',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'transform 0.3s, box-shadow 0.3s',
          }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'scale(1.05)';
              e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'scale(1)';
              e.target.style.boxShadow = 'none';
            }}
          >
            Plan Your Retreat
          </button></Link>
        </div>
      </section>
    </div>
  </>
  );
}

export default Camping;

